import styled, { css } from 'styled-components';

import { Spacer } from '@ontruck/orc';

const props = ({ theme }) => css`
  font-weight: bold;
`;

export default styled(Spacer).attrs(() => ({}))`
  ${props}
`;
